import { render, staticRenderFns } from "./Stop.vue?vue&type=template&id=89b848d8&"
import script from "./Stop.vue?vue&type=script&lang=js&"
export * from "./Stop.vue?vue&type=script&lang=js&"
import style0 from "./Stop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports